import React from 'react';

function HouseLine(props: object) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 20.75H22.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 20.75V14.75H9.75V20.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 11.4414V20.7517"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 20.7517V11.4414"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 12.9403L11.4694 3.71996C11.539 3.65023 11.6217 3.59491 11.7128 3.55717C11.8038 3.51943 11.9014 3.5 12 3.5C12.0986 3.5 12.1962 3.51943 12.2872 3.55717C12.3783 3.59491 12.461 3.65023 12.5306 3.71996L21.75 12.9403"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HouseLine;
